import React, { useEffect, useState } from "react";
import { api } from "../../lib/auth";

export default function Community() {
  const [groups, setGroups] = useState([]);
  useEffect(() => {
    api.get("/portal/community-groups").then((r) => setGroups(r.data.items || [])).catch(() => {});
  }, []);
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-extrabold tracking-tight text-[#0B132B]">Community</h1>
        <p className="text-[#4B5563] mt-2">Find your people. Join groups led by patients, survivors, and caregivers who understand.</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {groups.map((g) => (
          <div key={g.id} className="bg-white rounded-2xl border border-gray-100 p-6">
            <div className="text-[10px] font-bold uppercase tracking-wider text-[#23803F] mb-2">{g.category}</div>
            <h3 className="font-bold text-[#0B132B] text-lg">{g.name}</h3>
            <p className="text-sm text-[#4B5563] mt-2">{g.description}</p>
            <div className="flex items-center justify-between mt-5">
              <div className="text-xs text-[#4B5563]">{g.members?.toLocaleString()} members</div>
              <button className="btc-btn-primary text-xs px-5 py-2.5">Join</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
